import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hard-loader',
  templateUrl: './hard-loader.component.html',
  styleUrls: ['./hard-loader.component.css']
})
export class HardLoaderComponent implements OnInit {
  content: string = 'Loading';

  constructor() { }

  ngOnInit() {
  }

}
